export default {
    backgroundColor: '#6a5ecc38',
};
